import React, { useMemo } from 'react';
import { useTable, useSortBy, Row, Cell, HeaderGroup } from 'react-table';

import createNameColumn from '../utils/create-name-column';
import createPartyColumn from '../utils/create-party-column';

import { ITableRow } from '../types';

export interface IBasicTableRow extends ITableRow {
  title: string;
}

interface IBasicTableProps {
  data: IBasicTableRow[];
}

const columns = [
  createPartyColumn(),

  createNameColumn(),

  {
    accessor: 'title',
    Header: 'Title',
  },
];

const BasicTable: React.FC<IBasicTableProps> = ({ data }) => {
  const initialState = useMemo(
    () => ({
      sortBy: [{ id: 'name' }],
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      columns,
      data,
      disableSortBy: true,
      initialState,
    },
    useSortBy
  );

  return (
    <table
      {...getTableProps()}
      className="c-table c-table--striped t-links-underlined-hover l-width-full"
    >
      <thead>
        {headerGroups.map((headerGroup: HeaderGroup<IBasicTableRow>) => {
          const {
            key: headerGroupKey,
            ...headerGroupProps
          } = headerGroup.getHeaderGroupProps();

          return (
            <tr key={headerGroupKey} {...headerGroupProps}>
              {headerGroup.headers.map(
                (column: HeaderGroup<IBasicTableRow>) => {
                  const {
                    key: colHeaderKey,
                    ...colHeaderProps
                  } = column.getHeaderProps();

                  return (
                    <th
                      key={colHeaderKey}
                      {...colHeaderProps}
                      scope="col"
                      className="is-sr-only"
                    >
                      {column.render('Header')}
                    </th>
                  );
                }
              )}
            </tr>
          );
        })}
      </thead>

      <tbody {...getTableBodyProps()}>
        {rows.map((row: Row<IBasicTableRow>) => {
          prepareRow(row);

          const { key: rowKey, ...rowProps } = row.getRowProps();

          return (
            <tr key={rowKey} {...rowProps}>
              {row.cells.map((cell: Cell<IBasicTableRow>) => {
                const { key: cellKey, ...cellProps } = cell.getCellProps();

                return (
                  <td key={cellKey} {...cellProps}>
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default BasicTable;
